import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logout } from '../../../actions/associatesActions';
import { deleteCookie } from '../../../helpers/cookie';
import { getCategory } from '../../../helpers/category';
import UserIcon from '../../../components/icons/userIcon';
import LogoutIcon from '../../../components/icons/LogoutIcon';
import { useHistory } from 'react-router-dom';
import ItemMenu from './ItemMenu';
import { SecureIcon } from '../../../components/icons/SecureIcon';
import ContentApp from '../../../components/ContentApp';
import ConfigIcon from '../../../components/icons/ConfigIcon';
import { EyeIcon } from '../../../components/icons/EyeIcon';
import CardMenuIcon from '../../../components/icons/CardMenuIcon';


const MenuCustomer = ({ userTitle }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector((state) => state.associates.user);
  let categoryName = user?.salesCategory ? getCategory(user.salesCategory.category, t) : null;

  const handleSignOut = () => {
    dispatch(logout());
    deleteCookie('defaultCity');
    deleteCookie('selectedRestaurant');
  };
  const handleNotification = () => {
    history.push('/configuration');
  };

  const handleSeeCard = () => {
    history.push('/see-cards');
  };
  return (
    <ContentApp>
      <div className='menu-content'>
        <div className='row'>
          <div className='col pr-0 my-auto text-right'>
            <div className='user-channel font-tiny'>{userTitle}</div>
            <div className='font-large text-left lh-title'>
              {`${user?.firstName} ${user?.lastName}`}
            </div>
          </div>
        </div>
        {categoryName ? (
          <>
            <div className='light mt-1 text-capitalize'>{t('status')}</div>
            <div className='semi-bold'>{user.salesCategory.category}</div>
          </>
        ) : null}
        <nav className='mt-2 pt-1'>
          <ul className='mt-4'>
            <ItemMenu
              title={t('menu.profile')}
              icon={<UserIcon color='var(--color-font-primary)' size={'15px'} />}
              href={'#profile'}
            />

            <ItemMenu
              title={t('changePassword')}
              icon={<SecureIcon color='var(--color-font-primary)' size={'24px'} />}
              href={'#change-password'}
            />

            <ItemMenu
              title={t('menu.deleteAccount')}
              icon={<UserIcon color='var(--color-font-primary)' size={'15px'} />}
              href={'#delete-account'}
            />
            <ItemMenu
              title={t('seeCards')}
              icon={<CardMenuIcon color='var(--color-font-primary)' size={'15px'} />}
              onClick={handleSeeCard}
            />
            <ItemMenu
              title={t('menu.configuration')}
              icon={<ConfigIcon color='var(--color-font-primary)' size={'15px'} />}
              onClick={handleNotification}
            />

            <ItemMenu
              title={t('menu.logout')}
              icon={<LogoutIcon color='var(--color-font-primary)' size={'15px'} />}
              onClick={handleSignOut}
              className={'mt-5 pt-3'}
            />
          </ul>
        </nav>
        <div className='font-tiny mt-5 text-center' style={{ color: 'var(--color-font-gray)' }}>
          <div className='mt-3'>
            <span className='version'>v{process.env.REACT_APP_VERSION}</span>
          </div>
        </div>
      </div>
    </ContentApp>
  );
};
export default MenuCustomer;
